import { centsToDollars, parsePrice } from "helpers/price";
import { IProviderProcedure } from "types/ProviderProcedure";

import { CptCodePill } from "./CptCodePill";
import { StyledSuggestionRow } from "./styled";

export function parseSuggestion(suggestion: string) {
  return {
    code: suggestion.split(" ")[0].trim(),
    description: suggestion.split(" ").slice(2).join(" "),
  };
}

export function summariseCharges(
  code: string,
  providerProcedures: IProviderProcedure[]
) {
  const matches = providerProcedures.filter(
    (item) => item?.procedure?.cptCode === code
  );

  if (!matches.length) {
    return { charges: 0, subline: "", total: null as number | null };
  }

  const total = matches.reduce(
    (sum, item) => sum + (item.priceInCents || 0),
    0
  );

  return {
    charges: matches.length,
    subline:
      matches.length > 1
        ? `${matches.length} provider charges`
        : matches[0]?.provider?.name || "",
    total,
  };
}

export function CptSuggestion({
  suggestion,
  providerProcedures,
}: {
  suggestion: string;
  providerProcedures: IProviderProcedure[];
}) {
  const { code, description } = parseSuggestion(suggestion);
  const { charges, subline, total } = summariseCharges(
    code,
    providerProcedures
  );

  return (
    <StyledSuggestionRow>
      <span className="flex-shrink-0">
        <CptCodePill code={code} />
      </span>

      <div className="flex flex-column flex-1" style={{ minWidth: 0 }}>
        <span className="flex align-items-center gap-2">
          <span
            className="text-sm font-semibold line-height-2"
            style={{ color: "var(--brand-black)" }}
          >
            {description}
          </span>

          {charges > 1 && (
            <span
              className="flex-shrink-0 text-xs font-bold uppercase px-2 border-round-3xl"
              style={{
                background: "var(--brand-purple-700)",
                color: "var(--brand-white)",
                letterSpacing: "0.04em",
              }}
            >
              Bundle
            </span>
          )}
        </span>

        {!!subline && (
          <span
            className="text-xs line-height-2"
            style={{ color: "var(--brand-gray-500)" }}
          >
            {subline}
          </span>
        )}
      </div>

      {total !== null && (
        <span
          className="flex-shrink-0 text-sm font-bold white-space-nowrap"
          style={{ color: "var(--brand-black)" }}
        >
          {parsePrice(centsToDollars(total))}
        </span>
      )}
    </StyledSuggestionRow>
  );
}
